"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var bridge_1 = __importDefault(require("@stremio/stremio-core-web/bridge"));
var worker = new Worker("".concat(process.env.COMMIT_HASH, "/scripts/worker.js"));
var bridge = new bridge_1.default(window, worker);
var createTransport = function () {
    var init = function (args) {
        return bridge.call(['init'], [args]);
    };
    var getState = function (model) {
        return bridge.call(['getState'], [model]);
    };
    var dispatch = function (action, model) {
        return bridge.call(['dispatch'], [action, model, location.hash]);
    };
    var encodeStream = function (stream) {
        return bridge.call(['encodeStream'], [stream]);
    };
    var decodeStream = function (stream) {
        return bridge.call(['decodeStream'], [stream]);
    };
    var analytics = function (event) {
        return bridge.call(['analytics'], [event, location.hash]);
    };
    return {
        init: init,
        getState: getState,
        dispatch: dispatch,
        encodeStream: encodeStream,
        decodeStream: decodeStream,
        analytics: analytics,
    };
};
exports.default = createTransport;
